var map = {
	"./Vector.png": "83b1",
	"./advanced-invoice.png": "232c",
	"./cash.png": "1231",
	"./delivery.png": "fb15",
	"./inventory.png": "c08e",
	"./labeling.png": "d13c",
	"./next.png": "57f1",
	"./packing.png": "6794",
	"./premium-invoice.png": "ff6b",
	"./prev.png": "b032",
	"./starter-invoice.png": "4db6",
	"./storage.png": "1d6c",
	"./thanks.png": "f288"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f187";